var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"vx-row mt-3"},[_c('div',{staticClass:"vx-col w-full mb-base"},[_c('Table',{attrs:{"draw":_vm.draw,"status":_vm.activeTab,"warehouseId":this.warehouseId,"supplierId":this.supplierId}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }